import {isEmail} from 'class-validator'

import {UserFacingError} from './errors'

/**
 *
 * Throws a user-facing error if @param email is not a valid email address.
 */
export function validateEmail(email: string) {
  if (!isEmail(email)) {
    throw new UserFacingError('emailValidationError')
  }
}

export enum PlusEmailUsage {
  INCLUDE_PLUS,
  EXCLUDE_PLUS,
  ONLY_PLUS
}

export function isEmployeeEmailAddress(
  email: string,
  plusUsage: PlusEmailUsage = PlusEmailUsage.EXCLUDE_PLUS
): boolean {
  const rxEmployeeEmail = /@gingerlabs\.com$/
  if (!email.match(rxEmployeeEmail)) {
    return false
  }
  // Plus addresses (alex+foo@gingerlabs.com) are excluded by default because QA uses them as
  // stand-ins for non-employee accounts.
  const hasPlus = email.includes('+')
  switch (plusUsage) {
    case PlusEmailUsage.INCLUDE_PLUS:
      return true
    case PlusEmailUsage.EXCLUDE_PLUS:
      return !hasPlus
    case PlusEmailUsage.ONLY_PLUS:
      return hasPlus
  }
}

export function isInternalStarterEmail(email: string): boolean {
  const rxEmployeeEmail = /@gingerlabs\.com$/
  return !!email.match(rxEmployeeEmail) && email.includes('+starter')
}

export {isEmail} from 'class-validator'
